import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNursingLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_357_35532)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M16.305 10.5049L9.6792 3.87907C12.2342 1.32409 13.1686 4.45695 16.1589 1.46661L16.7986 0.827024C17.5051 0.120403 18.6507 0.120403 19.357 0.827024C20.0636 1.5334 20.0636 2.67908 19.3572 3.38546L18.7174 4.02529C15.7272 7.01555 18.86 7.94985 16.305 10.5049Z",
				fill: "#FCEA2B"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M16.9984 2.20549L17.6598 1.58806C18.0192 1.25273 18.2093 0.805053 18.2305 0.349976C18.7009 0.360463 19.1667 0.551234 19.5129 0.92241C20.1948 1.65269 20.1553 2.79776 19.4249 3.4793L18.7635 4.09673C15.6719 6.98208 18.7706 8.02386 16.129 10.4893L13.3765 7.6028C16.0181 5.13734 13.9068 5.09083 16.9984 2.20549Z",
				fill: "#F1B31C"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M15.1937 12.0903L7.85128 19.2598C7.00039 20.0906 5.60813 20.0906 4.75732 19.2598L0.678205 15.2769C-0.172683 14.446 -0.172683 13.0865 0.678205 12.2557L2.51392 10.4632L4.34956 8.67086L6.18519 6.87856L8.02071 5.08629C8.87168 4.25532 9.50021 3.63212 10.3511 4.46309L15.9032 10.1541C16.754 10.9849 16.0446 11.2595 15.1937 12.0903Z",
				fill: "#C6AAFC"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M1.94599 16.4208C2.79065 17.2517 4.17288 17.2517 5.01767 16.4208L12.3071 9.25138C13.1519 8.42049 13.1519 7.06107 12.3072 6.23027L11.2147 5.15576L15.5041 9.74751C16.3488 10.5783 16.109 11.329 15.2642 12.1598L7.97476 19.3293C7.13001 20.1602 5.74779 20.1602 4.90308 19.3293L0.853393 15.3464C0.853393 15.3464 0.853149 15.346 0.853027 15.3459L1.94599 16.4208Z",
				fill: "#8139D0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9.18662 9.81626L6.5415 7.17114",
				stroke: "white",
				strokeWidth: .604598,
				strokeMiterlimit: 10,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M7.48594 11.5166L4.84082 8.87146",
				stroke: "white",
				strokeWidth: .604598,
				strokeMiterlimit: 10,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M5.59678 13.4062L2.95166 10.761",
				stroke: "white",
				strokeWidth: .604598,
				strokeMiterlimit: 10,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_357_35532",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 20,
			height: 20,
			fill: "white"
		})
	}) })]
});
export default SvgNursingLogo;
